// Hero block schema - Full-width hero-style section (formerly Banner)
export const bannerSchema = {
  type: 'banner',
  label: 'Hero',
  description: 'Full-viewport hero section with heading, subheading, and optional button',
  icon: 'Image',
  defaultContent: {
    heading: 'Welcome',
    subheading: 'Add a description for your section',
    buttonText: '',
    buttonLink: '',
    backgroundImage: '',
    alignment: 'center', // 'left' | 'center' | 'right' - text alignment
    imageAlignment: 'center', // 'left' | 'center' | 'right' - image position for tall images
    overlayOpacity: 0.5,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Enter heading...' },
    { name: 'subheading', label: 'Subheading', type: 'textarea', placeholder: 'Enter subheading...' },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Learn More (optional)' },
    { name: 'buttonLink', label: 'Button Link', type: 'text', placeholder: 'https://...' },
    { name: 'backgroundImage', label: 'Background Image', type: 'image' },
    {
      name: 'alignment',
      label: 'Text Alignment',
      type: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      name: 'imageAlignment',
      label: 'Image Position',
      type: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      name: 'overlayOpacity',
      label: 'Overlay Darkness',
      type: 'range',
      min: 0,
      max: 1,
      step: 0.1,
    },
  ],
};
